// API endpoints configuration
import { API_DOMAIN, IMG_DOMAIN } from './domain';

export const API_CONFIG = {
  // Sitemap XML remote URL
  SITEMAP_URL: `${API_DOMAIN}/bot/xml.php`,
  // Phone → Country mapping endpoint (generato da be/bot/mapping.php)
  MAPPING_URL: import.meta.env.VITE_MAPPING_URL || `${API_DOMAIN}/bot/mapping.php`,
  // Country code detection endpoint
  COUNTRY_CODE_URL: import.meta.env.VITE_FG_ENDPOINT || `${IMG_DOMAIN}/fg.php`,
  // Authentication configuration
  AUTH: {
    MODEL: 'efusers',
    BASE_URL: `${API_DOMAIN}/api/v2/index.php`,
  },
  // Data models configuration
  MODELS: {
    ESCORTS: 'escorts',
    GALLERY: 'gallery',
  },
  // Countries configuration
  COUNTRIES: {
    ITALIA: {
      code: 'it',
      model: 'escorts_italia',
    },
    SVIZZERA: {
      code: 'ch', 
      model: 'escorts_svizzera',
    },
  },
};
